import React from 'react';
import { currentUserToken, isLoggedIn, onSessionChange } from './auth';

// The signed-in account's token, null when signed out: null on the server and
// on the client's first render, then the real answer after mount and on every
// session change (another tab's too). Reading localStorage during render would
// make the prerendered HTML and hydration disagree, and React would discard the
// prerender (docs/SEO-AUDIT.md bug #8). UserMenu makes the same choice.
export const useSessionToken = () => {
  const [token, setToken] = React.useState(null);
  React.useEffect(() => {
    const update = () => setToken(isLoggedIn() ? currentUserToken() : null);
    update();
    return onSessionChange(update);
  }, []);
  return token;
};

const useSignedIn = () => Boolean(useSessionToken());

export default useSignedIn;
